export default {
    
    titleId: 'bundle-seo-title-'+Math.random().toString(36).substr(2, 16),
    titleTag: 'h1',

    linkTitle: false,
    // inline settings
    buttonHref: 'https://www.appjustable.com',
    buttonTarget: '_blank',
    buttonText: 'Add Title',

    useBorderParent: false,
    useIndividualBorder: false,

    parentBorderWidth: 1,
    parentBorderType: 'solid',
    parentBorderColor: '#ccc',

    borderTopColorParent: '#cccccc',
    borderTopStyleParent: 'solid',
    borderTopWidthParent: 1,

    borderRightColorParent: '#cccccc',
    borderRightStyleParent: 'solid',
    borderRightWidthParent: 1,
    
    borderBottomColorParent: '#cccccc',
    borderBottomStyleParent: 'solid',
    borderBottomWidthParent: 1,
    
    borderLeftColorParent: '#cccccc',
    borderLeftStyleParent: 'solid',
    borderLeftWidthParent: 1,

    // style tag settings
    buttonTextFontSize: 14,
    buttonTextFontSizeTablet: null,
    buttonTextFontSizePhone: null,

    buttonPaddingHorizontal: 0,
    buttonPaddingVertical: 10,
    buttonPaddingHorizontalTablet: null,
    buttonPaddingVerticalTablet: null,
    buttonPaddingHorizontalPhone: null,
    buttonPaddingVerticalPhone: null,

    buttonMarginTop: 10,
    buttonMarginBottom: 10,

    buttonWidthSelect: 'auto',
    setButtonWidth: false,
    buttonWidth: 150,
    buttonMaxWidth: 'none',
    buttonWidthValue: 'auto',

    buttonWidthSelectTablet: null,
    setButtonWidthTablet: false,
    buttonWidthTablet: null,
    buttonMaxWidthTablet: null,
    buttonWidthValueTablet: null,

    buttonWidthSelectPhone: null,
    setButtonWidthPhone: false,
    buttonWidthPhone: null,
    buttonMaxWidthPhone: null,
    buttonWidthValuePhone: null,

    // widthClass: '',
    buttonBg: 'rgba(0,0,0,0)',
    buttonBgHover: 'rgba(0,0,0,0)',
    textColor: '#333',
    textColorHover: '#333',

    letterSpacing: 0,
    letterSpacingTablet: null,
    letterSpacingPhone: null,
    
    lineHeight: 1.2,
    lineHeightTablet: null,
    lineHeightPhone: null,

    borderRadiusGlobal: 0,

    showBorderRadiusIndividual: false,
    borderRadiusLeftTop: 0,
    borderRadiusRightTop: 0,
    borderRadiusRightBottom: 0,
    borderRadiusLeftBottom: 0,

    borderColor: '#aaa',
    borderColorHover: '#333',
    borderWidth: 0,
    borderStyle: 'solid',

    useButtonShadow: false,
    useButtonShadowOnHover: true,
    useButtonShadowOnNormal: false,
    buttonBoxShadowColor: 'rgba(0,0,0,.2)',
    buttonShadowHorizontal: 2,
    buttonShadowVertical: 7,
    buttonBlurRadius: 12,
    buttonSpreadRadius: 1,


    buttonAlignement: 'center',
    buttonAlignementTablet: null,
    buttonAlignementPhone: null,

    useIcon: false,

    useCustomFont: false,
    customFontName: "'Helvetica Neue', sans-serif",
    customFontWeight: "400",
    customFontStyle: 'normal',
    
    iconClass: 'fab fa-weebly',
    useIconAfter: false,
    useIconBefore: true,
    iconPosition: 'useIconBefore',
    iconMargin: 7,

    fontFamily: 'Roboto',
    fontWeight: '400',
    fontStyle: 'normal',
    fontGoogleLoad: 'Roboto:400'
    
}


// WEBPACK FOOTER //
// ./src/store/elementSettings/titlesettings.js